import type { ChangeEvent } from 'react';

import useDispatch from 'shared/hooks/useDispatch';
import useSelector from 'shared/hooks/useSelector';

import { selectSearchTerm } from '../../../selectors';
import { setSearchTerm } from '../../../slice';

import Search from 'shared/components/Search';

const SearchBar = () => {
  const dispatch = useDispatch();
  const searchTerm = useSelector(selectSearchTerm);

  const handleChangeSearchTerm = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(setSearchTerm(event.target.value));
  };

  return (
    <Search
      debounce
      placeholder="Hae"
      value={searchTerm}
      onChange={handleChangeSearchTerm}
    />
  );
};

export default SearchBar;
